module.exports = __webpack_public_path__ + "img/preview.dbc185b5.webp";